import type { ListItemButtonProps } from '@mui/material/ListItemButton'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { alpha, lighten, useTheme } from '@mui/material/styles'

export type ChataiConversationListItemProps = {
  loading?: boolean
  active?: boolean
} & ListItemButtonProps

export function ChataiConversationListItem({ children, active = false, ...props }: ChataiConversationListItemProps) {
  const theme = useTheme()
  const accent = '#20a3af'
  const accentLight = lighten(accent, 0.2)

  return (
    <ListItemButton
      {...props}
      sx={{
        'mx': 1,
        'my': 0.25,
        'borderRadius': '12px',
        'p': 0,
        'cursor': 'pointer',
        'overflow': 'hidden',
        'color': active
          ? accent
          : theme.palette.mode === 'dark'
            ? '#fff'
            : theme.palette.standard.main,
        'transition': theme.transitions.create(['background-color', 'color'], {
          duration: theme.transitions.duration.shorter,
        }),
        'svg': {
          width: '1.2rem',
          height: '1.2rem',
        },
        ...(active
          ? {
              'background': alpha(accentLight, 0.2),
              '&:hover': {
                background: alpha(accentLight, 0.26),
              },
            }
          : {
              '&:hover': {
                background: alpha(accent, 0.06),
                color: accent,
              },
            }),
        '& .MuiTypography-root, & .MuiSvgIcon-root': {
          color: 'inherit',
        },
      }}>
      <ListItemText
        slotProps={{
          primary: {
            sx: {
              fontSize: '0.875rem',
              fontWeight: active ? 700 : 500,
              letterSpacing: '0.01em',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          },
        }}>
        {children}
      </ListItemText>
    </ListItemButton>
  )
}
